//Libraries
import React from 'react';
import styled, { keyframes } from 'styled-components';

/**********
 ** Component: MainWrapper
 ** @type: functional stateless component
 ** @description: Layout Wrapper for the Main Area
 **********/
const MainWrapper = ({ children }) => (
  <Wrapper id="main-view" className="main-view">
    {children}
  </Wrapper>
);

const fadeInPage = keyframes`
  from {
    opacity: 0.01;
  }

  to {
    opacity: 1;
  }
`;

const Wrapper = styled.main`
  opacity: 0;
  animation-name: ${fadeInPage};
  animation-duration: 1000ms;
  animation-timing-function: ${props => props.theme.easeOutCirc};
  animation-fill-mode: forwards;
  flex: 1 0 auto;
`;

export default MainWrapper;



// WEBPACK FOOTER //
// ./src/components/general/main-wrapper/index.jsx